import { TransitionTypeController, ViewFinderWithShortcut } from '../../../services/transitionType/TransitionTypeController';
import { CyclingTransitionTypeFinder } from '../../../services/transitionType/CyclingTransitionTypeFinder';
import { DOMShortcutHandler } from '../../../utils/ShortcutHandler';
import { Key } from '../../../utils/Key';
import { IS_BLEEDING_EDGE } from '../../../utils/constants';
import { Nullable, TransitionType } from '../../../utils/types';
import { StaticTransitionTypeFinder } from '../../../services/transitionType/StaticTransitionTypeFinder';

let instance: Nullable<TransitionTypeController> = null;

class MainTransitionTypeController extends TransitionTypeController {
    static ensureInstance(staticView: TransitionType): TransitionTypeController {
        if (!instance) {
            instance = MainTransitionTypeController.createTransitionTypeController(staticView);
        }

        return instance;
    }

    private static createTransitionTypeController(staticView: TransitionType): TransitionTypeController {
        const viewFindersWithShortcut = MainTransitionTypeController.getViewFindersWithShortcut(staticView);
        return new TransitionTypeController(viewFindersWithShortcut);
    }

    private static getViewFindersWithShortcut(staticView: TransitionType): Array<ViewFinderWithShortcut> {
        const finders: Array<ViewFinderWithShortcut> = [];
        MainTransitionTypeController.addStaticFinder(finders, staticView);
        MainTransitionTypeController.addCyclingFinderIfTestEnvironment(finders);

        return finders;
    }

    private static addStaticFinder(
        findersWithShortcut: Array<ViewFinderWithShortcut>,
        staticView: TransitionType
    ): void {
        const staticFinder = MainTransitionTypeController.getStaticFinderWithShortcut(staticView);
        findersWithShortcut.push(staticFinder);
    }

    private static addCyclingFinderIfTestEnvironment(viewFindersWithShortcut: Array<ViewFinderWithShortcut>): void {
        if (IS_BLEEDING_EDGE) {
            viewFindersWithShortcut.push(MainTransitionTypeController.getCyclingFinderWithShortcut());
        }
    }

    private static getCyclingFinderWithShortcut() {
        return {
            viewFinder: new CyclingTransitionTypeFinder(),
            shortcutHandler: new DOMShortcutHandler([Key.Control, Key.c, Key.v])
        };
    }

    private static getStaticFinderWithShortcut(view: TransitionType): ViewFinderWithShortcut {
        const staticFinder = new StaticTransitionTypeFinder(view);
        return {
            viewFinder: staticFinder,
            shortcutHandler: new DOMShortcutHandler([Key.Control, Key.c, Key.x])
        };
    }
}

export { MainTransitionTypeController };


// WEBPACK FOOTER //
// ./src/webportal/components/hocs/transitionType/transitionTypeControllerInstance.ts